;(function (angular) {
  'use strict'

  angular
    .module('kilo.common.directives')
    .directive('textFormatter', TextFormatter)

  TextFormatter.$inject = []

  function TextFormatter () {
    return {
      restrict: 'A',
      require: 'ngModel',
      link: function (scope, elem, attrs, ngModel) {
        function formatValue (v) {
          if (v) {
            return v.replace(/<br>/g, '\n')
          }
        }

        ngModel.$formatters.push(formatValue)
        ngModel.$parsers.push(function (value) {
          value = value.replace(/\n/g, '<br>')
          return value
        })

        elem.bind('blur', function () {
          ngModel.$viewValue = formatValue(ngModel.$modelValue)
          ngModel.$render()
        })
      }
    }
  }
})(window.angular)
